import { configureStore } from "@reduxjs/toolkit";
import plantSlice from "./slices/plantSlice";
import terminalSlice from "./slices/terminalSlice";
import routeSlice from "./slices/routeSlice";
import meetingPointSlice from "./slices/meetingPointSlice";
import supplierSlice from "./slices/supplierSlice";
import relaySlice from "./slices/relaySlice";
import authSlice from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    supplier: supplierSlice,
    plant: plantSlice,
    terminal: terminalSlice,
    route: routeSlice,
    meetingPoint: meetingPointSlice,
    relay: relaySlice,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
